var TagManager = require('react-gtm-module');
var envDetails = require('./envDetails');

if(process.env.NODE_ENV === 'test'){
  var ua = require('ganalytics');
}else{
  var ua = require('ganalytics').default;
}
let  ENVIRONMENT = envDetails.constants
class Analytic {
  /**
   * 
   * @param {devAnalytic,qaAnalytic,prodAnalytic,tagManager} config 
   * @returns 
   */
  constructor(config) {
    if (Analytic.instance) {
      return Analytic.instance
    }

    this.gtmCode = config.tagManager
    switch (envDetails.active) {
      case ENVIRONMENT.DEVELOPMENT:
      case ENVIRONMENT.QA4:
        if(!config.devAnalytic) throw Error("Invalid analytic code, provide condfig.devAnalytic")
        this.analyticCode = config.devAnalytic
        break      
      case ENVIRONMENT.QA_BLUE:
      case ENVIRONMENT.QA:
        if(!config.qaAnalytic) throw Error("Invalid analytic code, provide condfig.qaAnalytic")
        this.analyticCode = config.qaAnalytic
        break
      case ENVIRONMENT.PRODUCTION:
      case ENVIRONMENT.BLUE:
      case ENVIRONMENT.PREPROD:
      default:
        if(!config.prodAnalytic) throw Error("Invalid analytic code, provide condfig.qaAnalytic")
        this.analyticCode = config.prodAnalytic
    }
    if (this.analyticCode !== '') {
      this.ua = ua(this.analyticCode)
    }
    Analytic.instance = this
    return this
  }

  getAnalytics() {
    return this.ua
  }
  /**
   * Please provide userId if you want to track events for each user.
   * userId is sent as part of data layer. Use userId to set as custom dimension in GTM.
   * @param {*} userId 
   */
  setUserId(userId) {
    this.ua = ua(this.analyticCode, { uid: userId })
    const tagManagerArgs = {
      gtmId: this.gtmCode,
      dataLayer: {
        userId,
        trackingId: this.analyticCode,
      },
    }
    TagManager.initialize(tagManagerArgs)
  }

  setPage(pageTitle, pagePath) {
    this.getAnalytics().send('pageview', { dt: pageTitle, dp: pagePath })
  }

  triggerEvent(events, dataLayer) {
    const tagManagerArgs = {
      gtmId: this.gtmCode,
      events,
      dataLayer,
    }
    TagManager.initialize(tagManagerArgs)
  }
  sendEvent(category, action, label) {
    this.getAnalytics().send('event', {
      ec: category,
      ea: action,
      el: label,
    })
  }

}

module.exports = Analytic
